import { http } from '@/http/axios.js'

// 列表
export function getListAPI(params) {
  return http({
    url: `/api/store/delivery/list`,
    method: 'get',
    params
  })
}

// 详情
export function getDetailAPI(id) {
  return http({
    url: `/api/store/address/detail`,
    method: 'get',
    params: { id }
  })
}
// add
export function addAPI(data) {
  return http({
    url: `/api/store/delivery/add`,
    method: 'post',
    data
  })
}
// 编辑
export function editAPI(data) {
  return http({
    url: `/api/store/delivery/edit`,
    method: 'post',
    data
  })
}
// del
export function delAPI(id) {
  return http({
    url: `/api/store/delivery/del`,
    method: 'post',
    data: { id }
  })
}

// 省市区
export function getCityListAPI(params) {
  return http({
    url: `/api/client/area/misc/tree`,
    method: 'get',
    params
  })
}
